import { removeTypeName } from '@modules/common/utils';
import { getCellMinimumHeightsByRowID } from '@modules/dashboard/helpers';
import { DashboardActionType } from '@modules/dashboard/store/dashboardActionType';
import { DashboardAction } from '@modules/dashboard/store/types';
import { DashboardViewFragment } from 'generated/graphql';
import { cloneDeep } from 'lodash';
import { generateMetadataV2 } from './generateMetadataV2';
import { resetLayoutIfRequired } from './resetLayoutIfRequired';

interface initMetadataV2Params {
  dashboard?: DashboardViewFragment;
  dispatch: (a: DashboardAction) => DashboardAction;
  cellMinimumHeightsByRowID: Record<string, Record<string, number>>;
}

export function initMetadataV2({
  dashboard,
  dispatch,
  cellMinimumHeightsByRowID,
}: initMetadataV2Params) {
  if (dashboard?.metadataV2?.layout) {
    const clonedMetadata = cloneDeep(dashboard.metadataV2);
    removeTypeName(clonedMetadata);
    // Workaround to restore missing analyses
    const layout = resetLayoutIfRequired({
      layout: clonedMetadata.layout,
      dashboard,
    });

    dispatch({
      type: DashboardActionType.SET_METADATA,
      payload: {
        ...clonedMetadata,
        layout,
      },
    });

    dispatch({
      type: DashboardActionType.SET_VISUAL,
      payload: {
        cellMinimumHeightsByRowID: getCellMinimumHeightsByRowID({
          layout,
          widgets: dashboard.widgets,
          baseCellMinimumHeightsByRowID: cellMinimumHeightsByRowID,
        }),
      },
    });

    return;
  }

  if (dashboard?.widgets?.length && !dashboard?.metadataV2?.layout) {
    const metadataV2 = generateMetadataV2(dashboard.widgets);

    dispatch({
      type: DashboardActionType.SET_METADATA,
      payload: metadataV2,
    });

    dispatch({
      type: DashboardActionType.SET_VISUAL,
      payload: {
        cellMinimumHeightsByRowID: getCellMinimumHeightsByRowID({
          layout: metadataV2.layout,
          widgets: dashboard.widgets,
        }),
      },
    });

    return;
  }
}
